import { render, staticRenderFns } from "./XKFinancial.vue?vue&type=template&id=b9454892&scoped=true&"
import script from "./XKFinancial.vue?vue&type=script&lang=js&"
export * from "./XKFinancial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9454892",
  null
  
)

export default component.exports